import React from "react";
import {Player, YoutubePlayer} from "./Player";
import HLSPlayer from "./Player/HLSPlayer";
import PenPencilVideo from "./Player/PenPencilVideo";

const AWSLive = React.lazy(() => import('./Player/AWSLive'));

interface VideoPlayerProps {
    type: 'PENPENCILVDO' | 'YOUTUBE' | 'AWS_LIVE' | 'MPD' | 'HLS' | 'MP4'
    src: string
    actions: any
    videoDetails?: any,
    defaultPaused: boolean,
    defaultMuted: boolean,
    loop: boolean,
    goToTime?: any
}


const VideoPlayerComponent = (props: VideoPlayerProps) => {
    console.log('>>>>>', props)
    if (props.type === 'MPD') {
        return <PenPencilVideo goToTime={props.goToTime} defaultPaused={props.defaultPaused} defaultMuted={props.defaultMuted} videoDetails={props.videoDetails} src={props.src}/>
    }
    if (props.type === 'PENPENCILVDO') {
        return <PenPencilVideo goToTime={props.goToTime} defaultPaused={props.defaultPaused} defaultMuted={props.defaultMuted} videoDetails={props.videoDetails} src={props.src}/>
    }
    if (props.type === 'AWS_LIVE') {
        return <React.Suspense fallback={<div>Loading...</div>}>
            <AWSLive goToTime={props.goToTime} videoDetails={props.videoDetails} src={props.src}/>
        </React.Suspense>
    }
    if (props.type === 'MP4') {
        return <Player src={props.src} goToTime={props.goToTime} videoDetails={props.videoDetails} defaultPaused={props.defaultPaused} defaultMuted={props.defaultMuted} loop={props.loop}/>

    }
    if (props.type === 'HLS') {
        return <HLSPlayer goToTime={props.goToTime} src={props.src}/>
    }
    if (props.type === 'YOUTUBE') {
        let isLive = true;
        if (!props.videoDetails.startTime || !props.videoDetails.endTime || new Date().getTime() > new Date(props.videoDetails.endTime).getTime() || new Date().getTime() < new Date(props.videoDetails.startTime).getTime()) {
            isLive = false;
        }
        return (
            <YoutubePlayer src={props.src} isLive={isLive} defaultPaused={props.defaultPaused} defaultMuted={props.defaultMuted}/>
        );
    }
    // parent.postMessage({
    //     type: 'EXIT_PLAYER'
    // }, '*');
    return <></>
}

export default VideoPlayerComponent;